<template>
  <div class="banner__layout">
    <div class="banner__banner banner_news">
      <Loader v-if="loading" />
      <template v-else>
        <div class="banner__left">
          <div class="banner__title">
            <h1>{{ theNews.name }}</h1>
          </div>
          <div class="banner__text">
            <p v-html="theNews.text"></p>
          </div>
          <div class="banner__category"></div>
        </div>
        <div class="banner__right">
          <img
            v-if="theNews.images != null"
            :src="theNews.images[0]"
            :alt="theNews.name"
          />
          <img
            v-else
            :src="require('@/assets/images/15MGKlq2K_DhuqHGMT0M9H.svg')"
            :alt="theNews.name"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  name: "NewsBanner",
  data: () => ({
    loading: true
  }),
  computed: mapGetters(["theNews"]),
  methods: mapActions(["fetchTheNews"]),
  mounted() {
    this.fetchTheNews(this.$route.params.id).then(() => (this.loading = false));
  }
};
</script>
